module.exports = __webpack_public_path__ + "static/t_28-80aa3359d7074587cf3ef6ebf14278c2.jpg";